<template>
  <validation-observer
    ref="generalScoreSaveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="generalScoreSaveModal"
      body-class="position-static"
      size="lg"
      centered
      no-close-on-backdrop
      :title="isCreated ? 'Thêm điểm' : 'Cập nhật điểm'"
      @show="onShow"
      @hide="onHide"
    >
      <b-form>
        <b-row>
          <b-col cols="12">
            <b-form-group label-for="name">
              <template v-slot:label>
                Tên điểm <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Tên điểm"
                rules="required"
              >
                <b-form-input
                  id="name"
                  v-model="targetData.name"
                  name="name"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <b-form-group label-for="scoringFormulaId">
              <template v-slot:label>
                Bộ công thức <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Bộ công thức"
                rules="required"
              >
                <v-select
                  v-model="targetData.scoringFormulaId"
                  label="name"
                  :options="scoringFormulas"
                  :reduce="option => option.id"
                  disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <b-form-group label-for="coefficient">
              <template v-slot:label>
                Hệ số điểm <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Hệ số điểm"
                rules="required|double"
              >
                <b-form-input
                  id="coefficient"
                  v-model="targetData.coefficient"
                  name="coefficient"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <b-form-group label-for="type">
              <template v-slot:label>
                Loại điểm <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Loại điểm"
                rules="required"
              >
                <v-select
                  v-model="targetData.type"
                  :options="types"
                  :reduce="option => option.value"
                  @input="onTypeChange"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            sm="12"
            md="6"
            lg="6"
            xl="6"
            class="d-flex align-items-center"
          >
            <b-form-checkbox
              v-model="targetData.isExamScore"
              value="1"
              unchecked-value="0"
            >
              Là điểm thi
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <b-form-group label-for="status">
              <template v-slot:label>
                Trạng thái <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Trạng thái"
                rules="required"
              >
                <v-select
                  v-model="targetData.status"
                  :options="statusOptions"
                  :reduce="option => option.value"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <b-form-group label-for="orderNo">
              <template v-slot:label>
                Thứ tự <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Thứ tự"
                rules="required"
              >
                <b-form-input
                  disabled
                  id="orderNo"
                  v-model="targetData.orderNo"
                  name="orderNo"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-show="isCreated"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu và tiếp tục
            </span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('generalScoreSaveModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        no-wrap
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BForm, BFormGroup, BModal, BOverlay, BButton, BFormInput, BRow, BCol, BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@core/utils/validations/validations'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import { showErrorToast, showSuccessToast } from '@/utils/notification'
import Ripple from 'vue-ripple-directive'
import { STATUSES } from '@/const/status'
import { getUser } from '@/auth/utils'

export default {
  name: 'GeneralScoreSave',
  components: {
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BOverlay,
    BButton,
    BRow,
    BCol,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    mainData: {
      type: Object,
      default: undefined,
    },
    scoringFormulaId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      targetData: {
        name: '',
        coefficient: null,
        type: 1,
        isExamScore: 0,
        scoringFormulaId: null,
        status: 1,
        orderNo: null,
      },
      types: [
        { value: 1, label: 'Lý thuyết' },
        { value: 2, label: 'Thực hành' },
      ],
      required,
    }
  },
  computed: {
    ...mapGetters({
      maxOrderNo: 'generalScore/maxOrderNo',
      scoringFormulas: 'generalScore/scoringFormulas',
    }),
    statusOptions() {
      return STATUSES
    },
    isCreated() {
      return !this.mainData
    },
  },
  methods: {
    ...mapActions({
      createData: 'generalScore/createData',
      updateData: 'generalScore/updateData',
      getMaxOrderNo: 'generalScore/getMaxOrderNo',
      getScoringFormulasByOrganization: 'generalScore/getScoringFormulasByOrganization',
    }),
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    async onTypeChange() {
      if (this.isCreated) await this.setOrderNo()
    },
    async onShow() {
      this.isLoading = true

      try {
        await this.getScoringFormulasByOrganization({ organizationId: this.user.orgId })
        if (this.isCreated) {
          this.targetData.scoringFormulaId = this.scoringFormulaId
          await this.setOrderNo()
        } else {
          this.targetData = { ...this.mainData }
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    onHide() {
      this.$refs
        .generalScoreSaveFormRef
        .reset()
      this.targetData = {
        name: '',
        coefficient: null,
        type: 1,
        isExamScore: 0,
        scoringFormulaId: null,
        status: 1,
        orderNo: null,
      }
    },
    async onSave(type = null) {
      const valid = this.$refs
        .generalScoreSaveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = this.isCreated
            ? await this.createData(this.targetData)
            : await this.updateData(this.targetData)
          if (response) {
            const { isSuccessful, message } = response
            if (isSuccessful) {
              showSuccessToast(this, message)
              if (type === 'hide') {
                this.$bvModal.hide('generalScoreSaveModal')
              }
              this.$emit('succeed')
            } else {
              showErrorToast(this, message)
            }
          }
        } catch (e) {
          showErrorToast(this, e)
        } finally {
          this.isLoading = false
        }
      }
    },
    async setOrderNo() {
      try {
        await this.getMaxOrderNo({
          scoringFormulaId: this.scoringFormulaId,
          type: this.targetData.type,
        })
        this.targetData.orderNo = this.maxOrderNo + 1
      } catch (e) {
        showErrorToast(this, e)
      }
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
